import ApplyProfilesForm from './apply-profiles.form';

export default ApplyProfilesForm;
